// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"GreenElecReCarbonEmissions_cardBoxSty__erKvU","echarts_wrapper":"GreenElecReCarbonEmissions_echarts_wrapper__XM1g1"};